import { useEffect, useRef } from 'react';
import { format } from 'date-fns';
import { jsPDF } from 'jspdf';
import PropTypes from 'prop-types';

import local from './formStyles/generateForm.module.css';

const GenerateForm = ({
    fileName,
    formCode,
    userCode,
    ptCode,
    onPdfGenerated,
    onClose,
    children
}) => {
    const templateRef = useRef(null);

    // USE EFFECTS
    useEffect(() => {
        if (!templateRef?.current) return;
        generatePdf();
    }, []);

    // FNs
    const createFooter = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();
        const pageSize = doc.internal.pageSize;
        doc.setFontSize(8);
        Array.from({ length: pageCount }, (_, i) => i + 1).forEach((pageNumber) => {
            doc.setPage(pageNumber);
            const footerText =
                `    Page ${pageNumber} of ${pageCount} ` +
                ' '.repeat(40) +
                ` Printed${userCode ? ` by ${userCode}` : ''} on ${format(new Date(), 'EEEE, MMMM dd, yyyy HH:mm')} Print ID: ${
                    formCode
                } MshpID: ${ptCode}`;

            doc.text(footerText, 1, pageSize.height - 5, { align: 'left' });
        });
    };

    const generatePdf = () => {
        const doc = new jsPDF();
        doc.html(templateRef.current, {
            async callback(doc) {
                createFooter(doc);
                // doc.output('dataurlnewwindow'); // to preview in a new browser window.
                doc.save(`${fileName}.pdf`);
                onPdfGenerated(true);
                onClose && onClose();
            },
            autoPaging: 'text',
            margin: [10, 0, 10, 0],
            width: 210,
            windowWidth: 1050
        });
    };

    // RENDER
    return (
        <div className={local.previewWrapper}>
            <div ref={templateRef} id="formTemplateContainer" data-testid="formTemplateContainer">
                {children}
            </div>
        </div>
    );
};

GenerateForm.propTypes = {
    fileName: PropTypes.string,
    formCode: PropTypes.string.isRequired,
    userCode: PropTypes.string.isRequired,
    ptCode: PropTypes.string.isRequired,
    onPdfGenerated: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    children: PropTypes.element
};

export default GenerateForm;
